	export function loadMonacoWorkers() {
		(self as any).MonacoEnvironment = {
			getWorker: function (_moduleId: any, label: any) {
				if (label === 'json') {
					// return new jsonWorker();
					return new Worker(new URL('vs/language/json/json.worker.js', import.meta.url));
				}
				// return new editorWorker();
				return new Worker(new URL('vs/editor/editor.worker.js', import.meta.url));
			}
		};
	}